import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'IndexView',
		component: () => import('../views/IndexView.vue')
	},
	{
		path: '/about',
		name: 'about',
		component: () => import('../views/AboutView.vue')
	},
	{
		path: '/product',
		name: 'product',
		component: () => import('../views/ProductView.vue')
	},
	{
		path: '/productInfo',
		name: 'productdetails',
		component: () => import('../views/ProductDetail.vue')
	},
	{
		path: '/BrandDynamics',
		name: 'BrandDynamics',
		component: () => import('../views/BrandDynamics.vue')
	},
	{
		path: '/BrandDetails',
		name: 'BrandDetails',
		component: () => import('../views/BrandDetails.vue')
	},
	{
		path: '/UserList',
		name: 'UserList',
		component: () => import('../views/UserList.vue')
	},
	{
		path: '/UserInfo',
		name: 'UserInfo',
		component: () => import('../views/UserInfo.vue')
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior() {
		return { left: 0, top: 0 }
	}
});

// 全局前置路由守卫
router.beforeEach(() => {
	// 设置页面title
	document.title ='番顺茶业';
});
// 全局后置路由守卫
router.afterEach(() => {
	// 设置页面title
	document.title ='番顺茶业';
});

export default router
